import * as React from 'react';
import { memo } from 'react';

var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgProjects = function SvgProjects(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 16v128c-35.299 0-64-28.701-64-64s28.591-64 64-64Z",
    fill: "#E6F0F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.478 91.234 80 101.532 57.522 91.234m44.956 0L127 80l-24.522-11.234m0 22.468L127 102.468 80 124l-47-21.532 24.522-11.234m0 0L33 80l24.522-11.234m0 0L33 57.532 80 36l47 21.532-24.522 11.234m-44.956 0L80 79.064l22.478-10.298",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var Memo = /*#__PURE__*/memo(SvgProjects);

export { Memo as default };
//# sourceMappingURL=projects.svg.js.map
